import React, { useEffect, useRef } from 'react';
import { Editor as DraftEditor } from 'draft-js';
import cn from 'classnames';
import { useEditorState } from '../../provider';
import { useHandlers } from './useHandlers';
import styles from './index.module.scss';

const blockTypes = {
  'header-one': 'H1',
  'header-two': 'H2',
  'header-three': 'H3',
  'unordered-list-item': 'custom-unordered-list-item',
  'ordered-list-item': 'custom-ordered-list-item',
};

const blockStyleFn = (block) => blockTypes[block.getType()] ?? null;

const Editor = ({ autoFocus = false, className }) => {
  const state = useEditorState();
  const handlers = useHandlers();

  const ref = useRef();
  useEffect(() => {
    if (autoFocus && ref.current) {
      ref.current.focus();
    }
  }, [autoFocus]);

  return (
    <div className={cn(styles.root, className)}>
      <DraftEditor
        ref={ref}
        editorState={state}
        blockStyleFn={blockStyleFn}
        {...handlers}
      />
    </div>
  );
};

export default Editor;
